import Cookies from "js-cookie";
import values from "../values";

const useAuth = () => {
  return Cookies.get(values.constants.USER.TOKEN) ? true : false;
};

export default useAuth;
